import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "flex flex-row ml-12" }
const _hoisted_4 = { class: "flex flex-row items-center" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 1,
  class: "w-px h-8 bg-gray-300 ml-8"
}
const _hoisted_8 = {
  key: 2,
  href: "https://hiring.axelerate.io/"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", { class: "text-white ml-8" }, "For Business", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = { class: "flex flex-row" }
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6 text-white"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
  })
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "absolute z-50 w-full flex flex-col items-start bg-white p-4"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://hiring.axelerate.io/",
  class: "mt-4"
}, [
  /*#__PURE__*/_createElementVNode("button", null, "For Business")
], -1)
const _hoisted_18 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["hidden lg:flex flex-row items-center justify-between py-4 pl-4 pr-6", _ctx.branding.bgColor])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
        }, [
          _createElementVNode("img", {
            class: "h-6",
            src: _ctx.branding.logo
          }, null, 8, _hoisted_2)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/'))),
            class: "text-white"
          }, "Jobs"),
          _createElementVNode("button", {
            class: "text-white ml-8",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/companies')))
          }, " Companies ")
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.token)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              target: "_blank",
              href: `http://id${_ctx.suffix}.axelerate.io/login`
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn-filled-sm", _ctx.branding.accentColor])
              }, " Login ", 2)
            ], 8, _hoisted_5))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          (_ctx.token && _ctx.showProfileButton && _ctx.isTalent)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["btn-filled-sm", _ctx.branding.accentColor]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/candidate-overview')))
              }, " My profile ", 2))
            : _createCommentVNode("", true),
          (_ctx.token && !_ctx.isTalent)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                target: "_blank",
                href: `http://id${_ctx.suffix}.axelerate.io`
              }, [
                _createElementVNode("button", {
                  class: _normalizeClass(["btn-filled-sm", _ctx.branding.accentColor])
                }, " Dashboard ", 2)
              ], 8, _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.token && !_ctx.branding.isWhiteLabel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7))
          : _createCommentVNode("", true),
        (!_ctx.branding.isWhiteLabel && !_ctx.token)
          ? (_openBlock(), _createElementBlock("a", _hoisted_8, _hoisted_10))
          : (_openBlock(), _createElementBlock("button", {
              key: 3,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
              class: "text-white ml-8"
            }, "Log out"))
      ])
    ], 2),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", {
        class: _normalizeClass(["lg:hidden flex flex-row items-center justify-between px-4 py-2", _ctx.branding.bgColor])
      }, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/')))
          }, [
            _createElementVNode("img", {
              class: "h-6",
              src: _ctx.branding.logo
            }, null, 8, _hoisted_13)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hamburgerMenu = !_ctx.hamburgerMenu)),
            class: _normalizeClass(["p-4 rounded", _ctx.branding.burgerBgColor])
          }, _hoisted_15, 2)
        ])
      ], 2),
      (_ctx.hamburgerMenu)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("button", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push('/')))
            }, "Jobs"),
            _createElementVNode("button", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push('/companies'))),
              class: "mt-4"
            }, " Companies "),
            _hoisted_17,
            (!_ctx.token)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  target: "_blank",
                  href: `http://id${_ctx.suffix}.axelerate.io/login`,
                  class: "w-full mt-8"
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["w-full btn-filled-sm", _ctx.branding.accentColor])
                  }, " Login ", 2)
                ], 8, _hoisted_18))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.hamburgerMenu)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.hamburgerMenu = false)),
            class: "absolute z-40 w-full min-h-screen bg-black opacity-50"
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}